import { InputSelect } from '../../../../../shared/components/InputSelect';
import { TabPanel } from '@mui/lab';
import { Checkbox, FormControlLabel } from '@mui/material';
import { SelectAutoCompleteComponent } from '../../../../../shared/components/SelectAutoCompleteComponent';
import { SelectAutoCompleteOptions } from '../../../../../shared/types/selectAutoComplete';
import { Input } from '../../../../../shared/components/Input';
import { InputMoney } from '../../../../../shared/components/InputMoney';
import Box from '@mui/material/Box';
import { OPTIONS_TRANSPORT } from '../../../../../shared/utils/const/TransportsOptions';

const UF_OPTIONS = [
  { value: 'AC', label: 'Acre' },
  { value: 'AL', label: 'Alagoas' },
  { value: 'AP', label: 'Amapá' },
  { value: 'AM', label: 'Amazonas' },
  { value: 'BA', label: 'Bahia' },
  { value: 'CE', label: 'Ceará' },
  { value: 'DF', label: 'Distrito Federal' },
  { value: 'ES', label: 'Espírito Santo' },
  { value: 'GO', label: 'Goiás' },
  { value: 'MA', label: 'Maranhão' },
  { value: 'MT', label: 'Mato Grosso' },
  { value: 'MS', label: 'Mato Grosso do Sul' },
  { value: 'MG', label: 'Minas Gerais' },
  { value: 'PA', label: 'Pará' },
  { value: 'PB', label: 'Paraíba' },
  { value: 'PR', label: 'Paraná' },
  { value: 'PE', label: 'Pernambuco' },
  { value: 'PI', label: 'Piauí' },
  { value: 'RJ', label: 'Rio de Janeiro' },
  { value: 'RN', label: 'Rio Grande do Norte' },
  { value: 'RS', label: 'Rio Grande do Sul' },
  { value: 'RO', label: 'Rondônia' },
  { value: 'RR', label: 'Roraima' },
  { value: 'SC', label: 'Santa Catarina' },
  { value: 'SP', label: 'São Paulo' },
  { value: 'SE', label: 'Sergipe' },
  { value: 'TO', label: 'Tocantins' },
];

interface TabTransporteProps {
  values: any;
  handleChange: any;
  handleBlur: any;
  touched: any;
  errors: any;
  setFieldValue: any;
  duploClick?: boolean;
  // [30/09] Boleto vivo trava o que muda o valor cobrado: modalidade, "somar frete" e
  // valor. Transportadora, placa e volumes continuam editaveis.
  travadoPorBoleto?: boolean;
  handleSearchTransport: (value: string) => void;
  transportOptions: SelectAutoCompleteOptions[];
  handleAutoCompleteSelectedTransport: (
    value: SelectAutoCompleteOptions
  ) => void;
}

export const TabTransporte = ({
  handleAutoCompleteSelectedTransport,
  transportOptions,
  handleSearchTransport,
  values,
  handleChange,
  handleBlur,
  touched,
  errors,
  setFieldValue,
  duploClick,
  travadoPorBoleto,
}: TabTransporteProps) => {
  const freteTravado = !!duploClick || !!travadoPorBoleto;


  // [30/09] '5': o Transporte passou a vir antes do Financeiro. O numero e a posicao da aba.
  return (
    <TabPanel value={'5'}>
      <fieldset disabled={duploClick}>
        <div className={'grid grid-cols-12 pt-4 gap-4'}>
          <InputSelect
            label='Tipo Frete*'
            name='transporte.mod_frete'
            size='small'
            items={OPTIONS_TRANSPORT}
            className={'col-span-4'}
            value={values?.transporte?.mod_frete}
            handleChange={handleChange}
            helperText={
              touched?.transporte?.mod_frete && errors?.transporte?.mod_frete
                ? errors?.transporte?.mod_frete
                : ''
            }
            error={
              !!(
                touched?.transporte?.mod_frete && errors?.transporte?.mod_frete
              )
            }
            disabled={freteTravado}
          />
          {values?.transporte?.mod_frete == 0 && (
            <FormControlLabel
              disabled={freteTravado}
              control={
                <Checkbox
                  checked={values?.transporte?.somar_frete_cif == 'S' || false}
                  name='transporte.somar_frete_cif'
                  onChange={(event) =>
                    setFieldValue(
                      'transporte.somar_frete_cif',
                      event.target.checked ? 'S' : 'N'
                    )
                  }
                />
              }
              className={'col-span-4'}
              label='Somar Frete CIF'
            />
          )}
          {values?.transporte?.mod_frete != 0 && (
            <Box className={'col-span-4'} />
          )}
          <SelectAutoCompleteComponent
            label={'Transportadora'}
            size='small'
            className='col-span-4'
            value={values?.transporte?.cli_nome ?? ''}
            name={'transporte.transportador_id'}
            options={transportOptions}
            handleSearch={(value: string) => handleSearchTransport(value)}
            onSelectValue={handleAutoCompleteSelectedTransport}
            disabled={duploClick}
          />
          <Input
            label='Código ANTT'
            name='transporte.codigo_antt'
            className={'col-span-4'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.transporte?.codigo_antt &&
              errors?.transporte?.codigo_antt
                ? errors?.transporte?.codigo_antt
                : ''
            }
            hasError={
              !!(
                touched?.transporte?.codigo_antt &&
                errors?.transporte?.codigo_antt
              )
            }
            value={values?.transporte?.codigo_antt ?? ''}
          />
          <Input
            label='Placa Veículo'
            name='transporte.placa_veiculo'
            className={'col-span-4'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.transporte?.placa_veiculo &&
              errors?.transporte?.placa_veiculo
                ? errors?.transporte?.placa_veiculo
                : ''
            }
            hasError={
              !!(
                touched?.transporte?.placa_veiculo &&
                errors?.transporte?.placa_veiculo
              )
            }
            value={values?.transporte?.placa_veiculo ?? ''}
          />
          <InputSelect
            label='UF Placa Veículo'
            name='transporte.uf_placa_veiculo'
            size='small'
            items={UF_OPTIONS}
            className={'col-span-4'}
            handleChange={handleChange}
            helperText={
              touched?.transporte?.uf_placa_veiculo &&
              errors?.transporte?.uf_placa_veiculo
                ? errors?.transporte?.uf_placa_veiculo
                : ''
            }
            error={
              !!(
                touched?.transporte?.uf_placa_veiculo &&
                errors?.transporte?.uf_placa_veiculo
              )
            }
            value={values?.transporte?.uf_placa_veiculo ?? ''}
            disabled={duploClick}
          />
          <InputMoney
            disabled={freteTravado}
            label={'Valor Frete'}
            className={'col-span-4'}
            name={'transporte.valor_frete'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.transporte?.valor_frete &&
              errors?.transporte?.valor_frete
                ? errors?.transporte?.valor_frete
                : ''
            }
            hasError={
              !!(
                touched?.transporte?.valor_frete &&
                errors?.transporte?.valor_frete
              )
            }
            value={values?.transporte?.valor_frete ?? ''}
          />
          <Input
            label='Marca'
            name='transporte.marca'
            className={'col-span-4'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.transporte?.marca && errors?.transporte?.marca
                ? errors?.transporte?.marca
                : ''
            }
            hasError={
              !!(touched?.transporte?.marca && errors?.transporte?.marca)
            }
            value={values?.transporte?.marca ?? ''}
          />
          <Input
            label='Peso Líquido (Kg)'
            name='transporte.peso_liquido_kg'
            className={'col-span-4'}
            type={'number'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.transporte?.peso_liquido_kg &&
              errors?.transporte?.peso_liquido_kg
                ? errors?.transporte?.peso_liquido_kg
                : ''
            }
            hasError={
              !!(
                touched?.transporte?.peso_liquido_kg &&
                errors?.transporte?.peso_liquido_kg
              )
            }
            value={values?.transporte?.peso_liquido_kg ?? ''}
          />
          <Input
            label='Peso Bruto (Kg)'
            name='transporte.peso_bruto_kg'
            className={'col-span-4'}
            type={'number'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.transporte?.peso_bruto_kg &&
              errors?.transporte?.peso_bruto_kg
                ? errors?.transporte?.peso_bruto_kg
                : ''
            }
            hasError={
              !!(
                touched?.transporte?.peso_bruto_kg &&
                errors?.transporte?.peso_bruto_kg
              )
            }
            value={values?.transporte?.peso_bruto_kg ?? ''}
          />
          <Input
            label='Quantidade Volumes'
            name='transporte.quantidade_volumes'
            className={'col-span-4'}
            type='number'
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.transporte?.quantidade_volumes &&
              errors?.transporte?.quantidade_volumes
                ? errors?.transporte?.quantidade_volumes
                : ''
            }
            hasError={
              !!(
                touched?.transporte?.quantidade_volumes &&
                errors?.transporte?.quantidade_volumes
              )
            }
            value={values?.transporte?.quantidade_volumes ?? ''}
          />
          <Input
            label='Tipo Espécie'
            name='transporte.tipo_especie'
            className={'col-span-4'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.transporte?.tipo_especie &&
              errors?.transporte?.tipo_especie
                ? errors?.transporte?.tipo_especie
                : ''
            }
            hasError={
              !!(
                touched?.transporte?.tipo_especie &&
                errors?.transporte?.tipo_especie
              )
            }
            value={values?.transporte?.tipo_especie ?? ''}
          />
          <Input
            label='Numeração'
            name='transporte.numeracao'
            className={'col-span-4'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.transporte?.numeracao && errors?.transporte?.numeracao
                ? errors?.transporte?.numeracao
                : ''
            }
            hasError={
              !!(
                touched?.transporte?.numeracao && errors?.transporte?.numeracao
              )
            }
            value={values?.transporte?.numeracao ?? ''}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={
                  values?.transporte?.informar_veiculo_nota_fiscal == 'S' ||
                  false
                }
                name='transporte.informar_veiculo_nota_fiscal'
                onChange={(event) =>
                  setFieldValue(
                    'transporte.informar_veiculo_nota_fiscal',
                    event.target.checked ? 'S' : 'N'
                  )
                }
              />
            }
            className={'col-span-4'}
            label='Informar dados do veículo na Nota Fiscal'
          />
        </div>
      </fieldset>
    </TabPanel>
  );
};
